export const SET_API_URL_DOMAIN = 'SET_API_URL_DOMAIN';
export const SET_TOKEN = 'SET_TOKEN';
export const SET_CHAT_CONFIG = 'SET_CHAT_CONFIG';
export const UPDATE_CHAT_CONFIG = 'UPDATE_CHAT_CONFIG';
export const SET_PERSIST_CHAT_DATA = 'SET_PERSIST_CHAT_DATA';
export const TOGGLE_SOUND_NOTIFICATIONS = 'TOGGLE_SOUND_NOTIFICATIONS';
